module.exports = __webpack_public_path__ + "static/media/departure-icon.a0b2db2c.svg";